/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Watery_Big_Seahorse_TreatInputs */

const fr_watery_big_seahorse_treat = /** @type {(inputs: Watery_Big_Seahorse_TreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'abonnement`)
};

/**

* @param {Watery_Big_Seahorse_TreatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const watery_big_seahorse_treat = /** @type {((inputs?: Watery_Big_Seahorse_TreatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watery_Big_Seahorse_TreatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_watery_big_seahorse_treat(inputs)
});